import { LARGE_UPS_SURCHARGE_USD } from '~/constants/carriers';
import { type TranslationFunction } from '~/utils/translate';

import { UPS_LARGE_PACKAGE_SURCHARGE } from './RateWarningConstants';
import { type Warning } from './RateWarningTypes';

export const deduplicateWarnings = (warnings: Warning[]): Warning[] => {
  const warningsMap: Record<string, Warning> = warnings.reduce((accum, curr) => {
    accum[curr.message] = curr;
    return accum;
  }, {});

  return Object.values(warningsMap);
};

/**
 * This function separates out the warnings in two arrays UPSWarnings and otherWarnings
 * @param warnings all warnings
 * @returns UPSWarnings and otherWarnings
 */
export const separateUPSSurchargeWarnings = (
  warnings: Warning[],
): {
  UPSWarnings: Warning[];
  nonUPSSurchargeWarnings: Warning[];
} => {
  const UPSWarnings: Warning[] = [];
  const nonUPSSurchargeWarnings: Warning[] = [];
  warnings.forEach((w, idx) => {
    if (w.kind === UPS_LARGE_PACKAGE_SURCHARGE) UPSWarnings.push(warnings[idx]);
    else nonUPSSurchargeWarnings.push(warnings[idx]);
  });
  return { UPSWarnings, nonUPSSurchargeWarnings };
};

export const getUPSWarningCardExpandableHeader = (
  t: TranslationFunction,
  warningKind: string,
): string => {
  switch (true) {
    case warningKind === UPS_LARGE_PACKAGE_SURCHARGE:
      return t('orders:table:errors:surchargeTitleUPS', {
        amount: {
          currency_iso: 'USD',
          minimumFractionDigits: LARGE_UPS_SURCHARGE_USD % 1 === 0 ? 0 : 2,
          value: LARGE_UPS_SURCHARGE_USD,
        },
      });
    default:
      return '';
  }
};

/**
 * sortDimension sorts the largest side to length,
 * the second largest side to width
 * and the third largest side to height
 * @param length
 * @param width
 * @param height
 * @returns and object with sorted length, width, height
 */
export const sortDimension = (
  length: string,
  width: string,
  height: string,
): {
  height: string;
  length: string;
  width: string;
} => {
  const dimensions = [length, width, height].map((i) => parseFloat(i));
  const sortedDimensions = dimensions.sort((a, b) => a - b);
  const stringifiedDimensions = sortedDimensions.map((i) => i.toString());
  return {
    height: stringifiedDimensions[0],
    length: stringifiedDimensions[2],
    width: stringifiedDimensions[1],
  };
};
